import React from "react";
import { useMediaQuery } from "react-responsive";
import { Provider as JotaiProvider } from "jotai";
import { RenovacionContratoPageWeb } from "./componentes";
import { useValidarUrl } from "hooks";

const RenovacionContratosPage = () => {
	const esMovil = useMediaQuery({ query: "(max-width: 860px)" });
	const esDesktop = useMediaQuery({ query: "(min-width: 860px)" });

	const { } = useValidarUrl();

	return (
		<JotaiProvider>
			{/* {esMovil && <TareasPendientesPageMovil />} */}
			{esDesktop && <RenovacionContratoPageWeb />}
		</JotaiProvider>
	);
};

export default RenovacionContratosPage;
